import * as React from "react";
import { useConfiguratorContext } from "../../../../../../../../Context/Context/ConfiguratorContext.js";
import { Expander } from "./Expander.js";
const ExpanderContainer = ({ children }) => {
  const { isFooterOpen } = useConfiguratorContext();
  return /* @__PURE__ */ React.createElement(Expander, { isExpanded: isFooterOpen }, children);
};
export {
  ExpanderContainer
};
//# sourceMappingURL=ExpanderContainer.js.map
